import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import Skeleton from "react-loading-skeleton";
import { forceCheck } from "react-lazyload";
import withCustomStyles from "./HorizontalProductsListPart.style";
import ProductTilePart from "./ProductTilePart";
import { GRail } from "./ui";
import { handleHorizontalScroll } from "../utils/AppUtils";
import { getProductIdFromUrl } from "../utils/UrlUtils";

const SKELETON_COUNT = 8;

// Product rail: title, optional "See all", arrows, and a scroll-snap row of
// product cards. `onScroll` is called near the right edge to load more.
class HorizontalProductsListPart extends React.PureComponent {
  componentDidMount() {
    const { onScroll, horizontalRef } = this.props;
    if (onScroll && horizontalRef.current) {
      this.scrollListener = () =>
        handleHorizontalScroll(horizontalRef.current, this.props.onScroll);
      horizontalRef.current.addEventListener("scroll", this.scrollListener, {
        passive: true
      });
    }
  }

  componentDidUpdate(prevProps) {
    // products arrived after mount: let the lazy cards that are in view load
    if (prevProps.products.length !== this.props.products.length) {
      setTimeout(forceCheck, 0);
    }
    const {
      horizontalRef,
      location: { pathname }
    } = this.props;
    const prid = getProductIdFromUrl(pathname);
    const oldPrid = getProductIdFromUrl(prevProps.location.pathname);
    if (
      prid !== oldPrid &&
      horizontalRef &&
      horizontalRef.current &&
      horizontalRef.current.scrollLeft > 0
    ) {
      horizontalRef.current.scrollLeft = 0;
    }
  }

  componentWillUnmount() {
    const { horizontalRef } = this.props;
    if (this.scrollListener && horizontalRef.current) {
      horizontalRef.current.removeEventListener("scroll", this.scrollListener);
    }
  }

  renderSkeleton(index) {
    const { classes } = this.props;
    return (
      <div
        key={`skeleton-${index}`}
        className={classes.skeleton}
        aria-hidden="true"
      >
        <Skeleton className={classes.skeletonTile} />
        <Skeleton height={20} width="45%" />
        <Skeleton height={18} width="90%" />
        <Skeleton height={16} width="35%" />
      </div>
    );
  }

  render() {
    const {
      products,
      state,
      listName,
      CTListName,
      horizontalRef,
      title,
      seeAllTo
    } = this.props;
    const loading = products.length === 0 && state === "fetching";

    return (
      <GRail
        title={title}
        seeAllTo={seeAllTo}
        arrows
        kind="product"
        scrollerRef={horizontalRef}
        ariaLabel={typeof title === "string" ? title : undefined}
      >
        {loading
          ? Array.from({ length: SKELETON_COUNT }, (_, i) =>
              this.renderSkeleton(i)
            )
          : products.map(product => (
              <ProductTilePart
                key={product.id}
                product={product}
                nameCharLimit={60}
                listName={listName}
                state={state}
                CTListName={CTListName}
                isHorizontal
              />
            ))}
      </GRail>
    );
  }
}

HorizontalProductsListPart.propTypes = {
  products: PropTypes.array.isRequired,
  horizontalRef: PropTypes.object.isRequired,
  title: PropTypes.node,
  seeAllTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onScroll: PropTypes.func,
  state: PropTypes.string,
  listName: PropTypes.string,
  CTListName: PropTypes.string
};

export default withRouter(withCustomStyles(HorizontalProductsListPart));
